module.exports = __webpack_public_path__ + "8ecd4de5a3d4b30556368996a89af9d9.mp4";